export default {
  'meta': {
    'langName': 'ESTONIAN',
    'lang': 'Eesti'
  },
  'title': 'TOOTE TAGASIKUTSUMINE – KORVPALLIKORV B900 BOX NBA TARMAK',
  'description': 'Tere!\n\n\nOstsite hiljuti korvpallikorvi Tarmak B900 BOX NBA ja me täname Teid ostu eest.\n\nOsana meie jätkuvast pühendumisest tootekvaliteedile ja ohutusele on DECATHLONi korvpallimeeskond tuvastanud võimaliku riski, et post kukub vertikaalselt ümber, kui kõrguse reguleerimise vänt on eemaldatud ja toodet seejärel käsitsetakse või kasutatakse.\n\nPalume, et vastaksite paarile küsimusele, et saaksime pakkuda Teie toote jaoks sobivat ohutuslahendust.\n\nPalume ebamugavuste pärast vabandust ja täname usalduse eest.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Esmalt kinnitage oma meiliaadress ja elukohariik:\n'
  },
  'fields': {
    'country': 'Riik',
    'address': 'Meiliaadress',
    'email': 'Meiliaadress',
    'phonePrefix': 'Telefoninumbri suunakood',
    'phone': 'Telefoninumber',
    'validations': {
      'phoneOrEmail': 'Sisestage vähemalt meiliaadress või telefoninumber.',
      'email': 'Sisestage kehtiv meiliaadress',
      'phone': 'Sisestage kehtiv telefoninumber'
    },
    'firstName': 'Perekonnanimi',
    'lastName': 'Eesnimi',
    'deliveryAddress': 'Paki kohaletoimetamise aadress',
    'additionalAddress': 'Täiendavad aadressiandmed',
    'city': 'Linn',
    'zip': 'Sihtnumber',
    'choose': 'Vali',
    'required': 'See väli on kohustuslik'
  },
  'ownerCheck': {
    'title': 'Kas Teil on endiselt üks või mitu B900 BOX NBA korvpallikorvi?\n'
  },
  'yes': 'JAH',
  'no': 'EI',
  'ownerChanged': {
    'title': 'Kas Teil on praeguse omaniku kontaktandmed?',
    'confirmation': 'Lp klient\n\nAitäh, et aitasite kaasa sellele kvaliteedialgatusele.\n\nPalume ebamugavuste pärast vabandust ja täname usalduse eest.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Palun lisage korvpallikorvide arv, mida omate, paigaldatud vända tüübi põhjal',
    'descriptionRed': 'Eemaldatava punase vändaga korvpallikorv',
    'descriptionBlack': 'Fikseeritud musta vändaga korvpallikorv',
    'quantity': 'Kogus',
    'notConcerned': 'Lp klient\n\nAitäh, et aitasite kaasa sellele kvaliteedialgatusele.\n\nVõite olla kindel, et tagasikutsumisprotsess ei mõjuta Teie korvpallikorvi Tarmak B900 BOX NBA. Seda on ohutu kasutada.\n\nPalume ebamugavuste pärast vabandust ja täname usalduse eest.\n\nDECATHLON',
    'concernedProductQuantity': 'Nõuetele mittevastava toote kogus:',
    'concernedProductLabel': 'Nõuetele mittevastav toode:',
    'confirmation': 'Täname Teid selle vormi täitmise eest. Teie taotlus on salvestatud.\n\nSaadame Teie komplekti saadetise jälgimisnumbri esimesel võimalusel.\n\nSoovime Teile ilusat päeva.\n\nDECATHLON'
  },
  'repair': {
    'title': 'Ise remontimine',
    'description': 'Oleme tuvastanud teatud korvpallikorvide TARMAK B900 BOX NBA puhul riski, et post võib vertikaalselt ümber kukkuda, kui vänt on eemaldatud ja seejärel toodet käsitsetakse või kasutatakse, tootekood 4239136.\nTeie vastuse põhjal tundub, et see risk mõjutab Teie toodet.\n\nSeetõttu palume Teil selle kasutamine kohe lõpetada ja pakume Teile abi vända kohandamisel, et saaksite oma toodet ohutult kasutada.\nVõite olla kindel, et see parandus ei nõua erioskusi – kõike selgitatakse selgelt videos ja allolevas kasutusjuhendis:\n',
    'videoLink': 'Video link',
    'docLink': 'Teatise link',
    'callToAction': 'Tasuta remondikomplekti saamiseks klõpsake siin',
    'warranty': 'Kogu protsess kuulub meie 5-aastase garantii alla.'
  },
  'repairRequest': {
    'title': 'Sisestage järgmine teave, et saaksime tasuta komplekti saata teie valitud aadressile:'
  },
  'form': {
    'submit': 'Edasi'
  },
  'status': 'Translation validated by COUNTRY'
} as const
